import React from 'react'
import PropTypes from 'prop-types'
import { ScheduleOrderItem } from './ScheduleOrderItem'

const ScheduledOrderList = props => {
  const onEdit = index => {
    props.onEdit(props.scheduledOrders[index])
  }

  const onDelete = index => {
    props.onDelete(props.scheduledOrders[index])
  }

  return (
    (props.scheduledOrders && props.scheduledOrders.length > 0 && (
      <div className='col-12 pt-2 border-top border-color-ui-3'>
        <div className='row'>
          <ul className='tracking-steps col-12 px-2'>
            {props.scheduledOrders &&
              props.scheduledOrders.map &&
              props.scheduledOrders.map((item, index) => (
                <ScheduleOrderItem
                  key={index}
                  serviceItemId={item.serviceItemId}
                  scheduleDate={item.scheduleDate}
                  description={item.description}
                  pointValue={item.pointValue}
                  vendorId={item.vendorId}
                  onEdit={onEdit}
                  onDelete={onDelete}
                  editable={item.editable}
                  hasCancel={
                    item.itemParticipantSchedule.serviceItem.findIndex(
                      item => item.status.statusName === 'Cancelado'
                    ) !== -1
                  }
                  index={index}
                />
              ))}
          </ul>
        </div>
      </div>
    )) ||
    ''
  )
}

ScheduledOrderList.propTypes = {
  scheduledOrders: PropTypes.array,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func
}

export default ScheduledOrderList



// WEBPACK FOOTER //
// ./src/Participant/Scheduling/ScheduledOrderList/ScheduledOrderList.js